import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import DocsEducacaoLogged from '../../../../components/auth/educacao/documentos'

function DocsEducacaoLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Módulo de Documentos da Secretaria Municipal de Educação" />
                <HeaderLogged />
                <Container>
                   <DocsEducacaoLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default DocsEducacaoLoggedScreen;